import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
import _ from "lodash";
import {
  CRUDLayout,
  Alert,
  DataStatus,
  ActionButton,
  UpdateButton,
  ReadButton,
  InputSearch,
  Pagination,
  Table,
  Th,
  Td,
  ThFixed,
  TdFixed,
  CreateButton,
  ApprovalStatusButton,
  FilterButton,
} from "components";
import {
  DateConvert,
  DecimalConvert,
  RupiahConvert,
  TableNumber,
} from "utilities";
import { PostingStockOpnameApi } from "api";
import { ModalFilter } from "./Section";
import { ExportButton, ModalSection } from "../Section";
import FileSaver from "file-saver";

export const ListPostingStockOpname = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataSuratJalan, setDataSuratJalan] = useState([]);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: location?.state?.surat_jalan?.filter?.active,
      tgl_stock_opname_master_mulai:
        location?.state?.surat_jalan?.filter?.tgl_stock_opname_master_mulai,
      tgl_stock_opname_master_selesai:
        location?.state?.surat_jalan?.filter?.tgl_stock_opname_master_selesai,
      tgl_posting_stock_opname_mulai:
        location?.state?.surat_jalan?.filter?.tgl_posting_stock_opname_mulai,
      tgl_posting_stock_opname_selesai:
        location?.state?.surat_jalan?.filter?.tgl_posting_stock_opname_selesai,
      id_item_barang: location?.state?.surat_jalan?.filter?.id_item_barang,
      id_gudang: location?.state?.surat_jalan?.filter?.id_gudang,
      is_opname: location?.state?.surat_jalan?.filter?.is_opname,
    },
    pagination: {
      page: location?.state?.surat_jalan?.filter?.page ?? "1",
      dataLength: location?.state?.surat_jalan?.filter?.dataLength ?? "10",
      totalPage: location?.state?.surat_jalan?.filter?.totalPage ?? "1",
      dataCount: location?.state?.surat_jalan?.filter?.dataCount ?? "0",
    },
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });
  const [searchTime, setSearchTime] = useState(null);
  const [modalConfig, setModalConfig] = useState({
    type: "detail",
    show: false,
    idStockOpnameDetail: null,
  });

  const [loadingExport, setLoadingExport] = useState(false);

  const getInitialData = () => {
    setIsPageLoading(true);

    PostingStockOpnameApi.page({
      q: searchConfig.key,
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_stock_opname_master_mulai:
        dataFilter?.filter?.tgl_stock_opname_master_mulai,
      tgl_stock_opname_master_selesai:
        dataFilter?.filter?.tgl_stock_opname_master_selesai,
      tgl_posting_stock_opname_mulai:
        dataFilter?.filter?.tgl_posting_stock_opname_mulai,
      tgl_posting_stock_opname_selesai:
        dataFilter?.filter?.tgl_posting_stock_opname_selesai,
      id_item_barang: dataFilter?.filter?.id_item_barang,
    })
      .then((data) => {
        setDataSuratJalan(data?.data?.data ?? []);
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            dataCount: data?.data?.data_count,
            totalPage: data?.data?.total_page,
          },
        });
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const onInputSearchChange = (text) => {
    const key = text.target.value;
    if (searchTime) clearTimeout(searchTime);
    setSearchTime(
      setTimeout(() => {
        setSearchConfig({
          ...searchConfig,
          key: text.target.value,
        });
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            page: "1",
            dataLength: "10",
            totalPage: "1",
            dataCount: "0",
          },
        });
        setAlertConfig({
          show: key ? true : false,
          variant: "primary",
          text: "Hasil dari pencarian: " + key,
        });
      }, 750)
    );
  };

  const exportData = (tipe) => {
    setLoadingExport(true);

    PostingStockOpnameApi.export({
      tgl_stock_opname_master_mulai:
        dataFilter?.filter?.tgl_stock_opname_master_mulai,
      tgl_stock_opname_master_selesai:
        dataFilter?.filter?.tgl_stock_opname_master_selesai,
      tgl_posting_stock_opname_mulai:
        dataFilter?.filter?.tgl_posting_stock_opname_mulai,
      tgl_posting_stock_opname_selesai:
        dataFilter?.filter?.tgl_posting_stock_opname_selesai,
      id_item_barang: dataFilter?.filter?.id_item_barang,
      tipe,
    })
      .then((res) => {
        const data = res.data.data;
        // const urlFile = process.env.REACT_APP_EXPORT_BASE_URL + data;
        FileSaver.saveAs(data, data);
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Export Data gagal",
        });
      })
      .finally(() => setLoadingExport(false));
  };

  useEffect(() => {
    setNavbarTitle("Posting Stock Opname");
    getInitialData();
    checkAlert();

    return () => {
      setIsPageLoading(false);
    };
  }, [
    searchConfig.key,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_stock_opname_master_mulai,
    dataFilter?.filter?.tgl_stock_opname_master_selesai,
    dataFilter?.filter?.tgl_posting_stock_opname_mulai,
    dataFilter?.filter?.tgl_posting_stock_opname_selesai,
    dataFilter?.filter?.id_item_barang,
    dataFilter?.filter?.id_gudang,
    dataFilter?.filter?.is_opname,
    dataFilter?.filter?.status_approval,
  ]);

  const PageContent = () => {
    const DataTable = () => (
      <>
        <span style={{ fontSize: "14px" }}>
          <b>List Data Posting Stock Opname</b>
        </span>
        <Table>
          <thead>
            <tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <ThFixed>Informasi Posting Stock Opname</ThFixed>
              <ThFixed>Informasi Stock Opname</ThFixed>
              <Th>Item Barang</Th>
              <Th>Qty. Adjustment</Th>
              <Th>Jumlah</Th>
              <Th>Akun COA</Th>
              <Th>Keterangan</Th>
            </tr>
          </thead>
          <tbody>
            {dataSuratJalan.map((val, index) => (
              <tr key={index}>
                <TdFixed>
                  {TableNumber(
                    dataFilter?.pagination?.page,
                    dataFilter?.pagination?.dataLength,
                    index
                  )}
                </TdFixed>
                <Td className="d-flex">
                  <ReadButton
                    size="sm"
                    onClick={() =>
                      setModalConfig({
                        ...modalConfig,
                        idStockOpnameDetail: val.id_posting_stock_opname,
                        show: true,
                      })
                    }
                  />
                </Td>
                <TdFixed>
                  <div className="text-left">
                    {val.tgl_posting_stock_opname
                      ? DateConvert(new Date(val.tgl_posting_stock_opname))
                          .defaultDMY
                      : "-"}
                  </div>
                  <div className="text-left">
                    {val.no_posting_stock_opname ?? "-"}
                  </div>
                </TdFixed>
                <TdFixed>
                  <div className="text-left">
                    {val.tgl_stock_fisik_master
                      ? DateConvert(new Date(val.tgl_stock_fisik_master))
                          .defaultDMY
                      : "-"}
                  </div>
                  <div className="text-left">
                    {val.no_stock_opname_master ?? "-"}
                  </div>
                </TdFixed>

                <Td>{val?.nama_item ?? "-"}</Td>
                <Td>
                  {
                    DecimalConvert(parseFloat(val.qty_adjustment ?? 0))
                      .getWithComa
                  }
                </Td>
                <Td>
                  {
                    RupiahConvert(parseFloat(val?.jumlah ?? 0).toString())
                      .getWithComa
                  }
                </Td>
                <Td>
                  <div>
                    {`
                    D : ${val.nomor_akun_debet ?? "-"} - ${
                      val?.nama_akun_debet ?? "-"
                    }
                  `}
                  </div>
                  <div>
                    {`
                    K : ${val.nomor_akun_kredit ?? "-"} - ${
                      val?.nama_akun_kredit ?? "-"
                    }
                  `}
                  </div>
                </Td>
                <Td>{val?.keterangan_jurnal ?? "-"}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );

    if (!dataSuratJalan || dataSuratJalan.length < 1) {
      return <DataStatus text="Tidak ada data" />;
    }

    return (
      <>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={dataFilter?.pagination?.dataLength}
            dataNumber={
              dataFilter?.pagination?.page *
                dataFilter?.pagination?.dataLength -
              dataFilter?.pagination?.dataLength +
              1
            }
            dataPage={
              dataFilter?.pagination?.dataCount <
              dataFilter?.pagination?.dataLength
                ? dataFilter?.pagination?.dataCount
                : dataFilter?.pagination?.page *
                  dataFilter?.pagination?.dataLength
            }
            dataCount={dataFilter?.pagination?.dataCount}
            currentPage={dataFilter?.pagination?.page}
            totalPage={dataFilter?.pagination?.totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: selected + 1,
                },
              })
            }
            onDataLengthChange={(e) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: 1,
                  dataLength: e.target.value,
                },
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      {/* Head Section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch onChange={onInputSearchChange} />
            <FilterButton
              active={dataFilter?.filter?.active}
              onClick={() => setShowModalFilter(true)}
            />

            <ExportButton
              loading={loadingExport}
              // disabled={!dataFilter?.filter?.active}
            >
              <Dropdown.Item onClick={() => exportData("excel")}>
                Excel (.xlsx)
              </Dropdown.Item>
            </ExportButton>
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          <CreateButton
            onClick={() =>
              history.push("/transaksi/posting-stock-opname/stock-opname", {
                ...location?.state,
                surat_jalan: dataFilter,
                action: "ADD",
              })
            }
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* Content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <PageContent />
      )}
      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
        />
      )}

      {modalConfig.show && (
        <ModalSection
          modalConfig={modalConfig}
          setModalConfig={setModalConfig}
        />
      )}
    </CRUDLayout>
  );
};
